module.exports = __webpack_public_path__ + "img/Tchnics1210_player.ca579f44.png";